import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Divider } from '@material-ui/core';
import { Breadcrumb } from 'components';
import ButtonLikeTabs from 'components/common/ButtonLikeTabs/ButtonLikeTabs';
import TextBox from 'components/common/TextBox/TextBox';
import LoadButton from 'components/common/LoadButton/LoadButton';
import CheckBox from 'components/common/CheckBox/CheckBox';

import { createPassword } from '../../Utils/Utils';

import './Setting.scss';

const CreateAccount = () => {
  const history = useHistory();
  const nextLink = '/setting/account-confirm'
  const [text, setText] = useState({ userName: '', userId: '', password: '' });
  const [check, setCheck] = useState({ userName: '', userId: '', password: '' });

  const handleChange = (event) => {
    setCheck({ ...check, [event.target.name]: event.target.checked });
  };

  const newUserId = () => {
    const userId = createPassword()
    setText({ ...text, userId: userId });
  }

  const newPassword = () => {
    const password = createPassword()
    setText({ ...text, password: password });
  }

  return (
    <div id="CreateAccount" className="pb-24 px-8 bg-default">
      <div className="breadcrumb">
        <Breadcrumb routeSegments={[{ name: '設定メニュー', path: '/setting/account' }, { name: 'アカウント発行' }]} />
      </div>

      <h2>アカウント発行</h2>
      <Divider style={{ backgroundColor: "#777", marginBottom: 20 }} className="topDivider" />

      <ButtonLikeTabs text1="発行" text2="発行先一覧" disabled={'text1'}
        link="/setting/account-all" />


      <div className="flexDiv">
        <div className="label">発行先名</div>
        <TextBox
          name="searchTextBox"
          onChange={(e) => { setText({ ...text, userName: e.target.value }); }}
          value={text.userName}
          label="発行先名"
        />
      </div>

      <div className="flexDiv">
        <div className="label">ユーザーID</div>
        <TextBox
          name="searchTextBox"
          onChange={(e) => { setText({ ...text, userId: e.target.value }); }}
          value={text.userId}
          label="ユーザーID"
        />
        <LoadButton text="ランダム英数生成" onClick={() => { newUserId() }} />
      </div>

      <div className="flexDiv">
        <div className="label">パスワード</div>
        <TextBox
          name="searchTextBox"
          onChange={(e) => { setText({ ...text, password: e.target.value }); }}
          value={text.password}
          label="パスワード"
        />
        <LoadButton text="ランダム英数生成" onClick={() => { newPassword() }} />
      </div>

      <h4 className='mt-sm-20'>制限するコンテンツ</h4>
      <div className="text">アカウント発行者に閲覧させないコンテンツを指定してください。</div>

      <div style={{ display: 'grid', }}>
        <CheckBox
          label="加盟店用"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
          boxColor="#EE0000"
        />
        <CheckBox
          label="本部用"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
          boxColor="#EE0000"
        />
      </div>

      <div style={{ display: 'grid', }}>
        <CheckBox
          label="HOME"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="店舗検索"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="売上"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="現金管理"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="IR開示情報"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="店舗分析"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・売上比較"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・非既存店・既存店分析"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="メニュー売上分析"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・オーダー率ランキング"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・部門別ABC表"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・ABC表"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・ﾒﾆｭｰ別点数ﾗﾝｷﾝｸﾞ[日別]"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・店舗別メニュー別構成比"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="仕入明細"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・店舗仕入実績"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・月別業態地区別仕入数量"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・店舗別食材売上推移（月次）"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・食材売上額・生餃子出荷数前年比（店・月別）"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・食材売上検証"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・食材売上額・生餃子出荷数前年比（店・月別）"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="営業日報"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・入力"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・閲覧"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="キングオブ大阪王将"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・売上部門"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・客数部門"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・餃子部"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・販促部門"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・店舗運営力部門"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・ナホオーダー率部門"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・指定食材減点"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
        <CheckBox
          label="・総合順位"
          checked={check.checkedA}
          onChange={handleChange}
          name="checkedA"
          checked={check.checkedA}
        />
      </div>

      <div className='mt-sm-20 createButton'>
        <LoadButton text="発行する" onClick={() => { history.push(nextLink) }} />
      </div>
    </div>
  );
};

export default CreateAccount;
